import styled from 'styled-components'

export const MenuOption = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgb(32, 32, 32);
  opacity: ${(p) => (p.disabled ? '0.7' : 1)};
  overflow: hidden; // Ensure text does not overflow
  text-overflow: ellipsis; // Apply ellipsis for overflowed text
  width: 100%; // Ensure it takes full width
  white-space: 'normal'; // Allow text to wrap
  word-break: 'break-word'; // Break long words
`;

export const MenuListFooter = styled.div`
  padding: 16px;
  border-top: 1px solid rgba(32, 32, 32, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MenuListActions = styled.div`
  display: flex;
`;
